import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/legal/privacy-policy')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="mx-auto max-w-4xl px-6 py-16 lg:px-8 lg:py-24">
      <h1 className="mb-8 font-display text-4xl font-semibold tracking-tight text-black md:text-5xl">
        Privacy Policy
      </h1>
      
      <p className="mb-8 text-lg text-black/70">
        <strong>Effective Date:</strong> March 02, 2025
      </p>

      <div className="prose prose-lg max-w-none space-y-8 text-black/80">
        <p>
          CoPlane, Inc. ("CoPlane," "we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and safeguard your personal data when you visit our website, interact with our marketing, and exercise your rights under applicable privacy laws.
        </p>

        <section>
          <h2 className="mb-4 mt-10 font-display text-2xl font-semibold text-black md:text-3xl">
            1. Information We Collect
          </h2>
          <p className="mb-4">We collect the following personal data:</p>
          <ul className="mb-6 list-disc space-y-2 pl-6">
            <li>Name</li>
            <li>Email Address</li>
            <li>Job Title</li>
            <li>Company Name</li>
            <li>IP Address</li>
          </ul>

          <h3 className="mb-4 mt-8 text-xl font-semibold text-black">How We Collect Your Data</h3>
          <p className="mb-4">We collect this data through:</p>
          <ul className="mb-6 list-disc space-y-2 pl-6">
            <li>Sign-up, opt-in and subscribe forms on our website</li>
            <li>Web analytics tracking</li>
            <li>Enrichment providers</li>
          </ul>

          <h3 className="mb-4 mt-8 text-xl font-semibold text-black">Why We Collect Your Data</h3>
          <p className="mb-4">
            We use your personal data for marketing purposes, such as sending relevant updates, personalized content, and engagement tracking.
          </p>

          <h3 className="mb-4 mt-8 text-xl font-semibold text-black">Do We Share Your Data?</h3>
          <p className="mb-4">
            We share data with analytics providers to help us understand website engagement and improve our marketing efforts.
          </p>
        </section>

        <section>
          <h2 className="mb-4 mt-10 font-display text-2xl font-semibold text-black md:text-3xl">
            2. Cookies & Tracking Technologies
          </h2>
          <p className="mb-4">
            We use cookies and tracking technologies to enhance your experience and improve our marketing efforts. Specifically, we use Attio and Clay for tracking and analytics.
          </p>

          <h3 className="mb-4 mt-8 text-xl font-semibold text-black">Opt-Out Options</h3>
          <p className="mb-4">
            Users can opt out of cookies via our website's cookie settings.
          </p>
        </section>

        <section>
          <h2 className="mb-4 mt-10 font-display text-2xl font-semibold text-black md:text-3xl">
            3. Data Storage, Security & Retention
          </h2>

          <h3 className="mb-4 mt-8 text-xl font-semibold text-black">Where We Store Your Data</h3>
          <p className="mb-4">Your data is stored in:</p>
          <ul className="mb-6 list-disc space-y-2 pl-6">
            <li>Attio</li>
            <li>Clay</li>
            <li>Snowflake</li>
          </ul>

          <h3 className="mb-4 mt-8 text-xl font-semibold text-black">How We Protect Your Data</h3>
          <p className="mb-4">
            We use industry-standard encryption to safeguard your personal data from unauthorized access and breaches.
          </p>

          <h3 className="mb-4 mt-8 text-xl font-semibold text-black">Data Retention</h3>
          <p className="mb-4">
            We retain your data perpetually unless you request deletion.
          </p>
        </section>

        <section>
          <h2 className="mb-4 mt-10 font-display text-2xl font-semibold text-black md:text-3xl">
            4. Your Rights & Choices
          </h2>
          <p className="mb-4">Under GDPR and CCPA, you have the following rights:</p>
          <ul className="mb-6 list-disc space-y-2 pl-6">
            <li><strong>Request Deletion:</strong> You may request the deletion of your personal data.</li>
            <li><strong>Opt-Out of Marketing:</strong> You can unsubscribe from marketing communications at any time.</li>
          </ul>
          <p className="mb-4">
            To exercise these rights, contact us at{' '}
            <a href="mailto:privacy@coplane.com" className="text-black underline hover:text-black/70">
              privacy@coplane.com
            </a>.
          </p>
        </section>

        <section>
          <h2 className="mb-4 mt-10 font-display text-2xl font-semibold text-black md:text-3xl">
            5. Third-Party Services
          </h2>
          <p className="mb-4">
            We use Amplitude, Attio and Clay to process user data for analytics and marketing. Users are not subject to third-party privacy policies beyond this Privacy Policy.
          </p>
        </section>

        <section>
          <h2 className="mb-4 mt-10 font-display text-2xl font-semibold text-black md:text-3xl">
            6. Privacy Policy Updates & Contact Information
          </h2>
          <p className="mb-4">
            We may update this Privacy Policy from time to time. If changes occur, we will notify users via a website banner.
          </p>
          <p className="mb-4">
            For privacy-related inquiries, contact us at:{' '}
            <a href="mailto:founders@coplane.com" className="text-black underline hover:text-black/70">
              founders@coplane.com
            </a>
          </p>
        </section>
      </div>
    </div>
  )
}
